export default "__VITE_ASSET__CEOY_Sqo__"